import { useState, useCallback, useEffect } from 'react';
import { COOKIES } from '../constants';
import deconstructLocation from '../utils/deconstructLocation';

const { USER_LAST_LOCATION } = COOKIES;

const useUserLocation = (
  { getCookie, setCookie },
  { loading, location: geoLocation }
) => {
  const [location, setLocation] = useState(getCookie(USER_LAST_LOCATION) || {});

  const setLocationAll = useCallback(
    obj => {
      const { state, postcode } = deconstructLocation(
        obj && obj.path ? obj.path : ''
      );
      const userLocation = {
        ...obj,
        url_name: obj && obj.path ? obj.path : '',
        state,
        postcode,
      };
      setCookie(USER_LAST_LOCATION, userLocation);
      setLocation(userLocation);
    },
    [setCookie]
  );

  // const setLocationGeo = useCallback(
  //   callback => {
  //     fetchGeo(callback);
  //   },
  //   [fetchGeo]
  // );

  useEffect(() => {
    if (geoLocation) {
      setLocationAll(geoLocation);
    }
  }, [geoLocation, setLocationAll]);

  return {
    location,
    geoLocation,
    setLocation: setLocationAll,
    // setLocationGeo,
    loading,
    // fetchGeo,
  };
};

export default useUserLocation;
